export default {"src":"/_next/static/media/honey.2b4dc3fb.svg","height":64,"width":64};